import React from "react";
import "./styles/App.css";
// import { Route, Routes } from "react-router-dom";
import ScoreBoardPage from "./pages/ScoreBoardPage";
// import HomePage from "./pages/HomePage";
// import NotFoundPage from "./pages/NotFoundPage";
// import { HashRouter } from "react-router-dom";

function App() {
  return (
    <ScoreBoardPage />
    // <HashRouter basename="/">
    //   <Routes>
    //     <Route path="/scoreboard" element={<ScoreBoardPage />} />
    //     <Route path="/" element={<HomePage />} />
    //     <Route path="*" element={<NotFoundPage />} />
    //   </Routes>
    // </HashRouter>
  );
}

export default App;
